var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('LoginDialogTemplate',{staticClass:"login-to-show-company-dialog",attrs:{"options":{
    ..._vm.options,
    redirectUrl: _vm.redirectUrl,
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }